import defaultQrCode from '#themes/default/default/components/qrCode/qrCode.js';

import cSvg from '#themes/default/web/components/svg/svg.js';

export default {
	components: {
		cSvg
	},
	extends: defaultQrCode
};
